import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import LinearProgress from '@material-ui/core/LinearProgress'
import SignIn from 'src/components/home/LoginComponent'
import credentialService, { SITE_KEY } from 'src/services/credentialService'
import useQuery from 'src/utils/hooks/useQuery'
import swal from 'sweetalert'
import { swalMessages } from '../../constants/index'
import loadScriptByURL from '../../utils/loadScriptRecapchat'

const RecoverContainer = () => {
  const [user, setUser] = useState({})
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const query = useQuery().get('t')

  let menssage = ''
  let errorMsg = ''

  if (query) {
    menssage = 'Ingresa una nueva Contraseña'
  } else {
    menssage = 'Ingresa correo de recuperación'
  }

  useEffect(() => {
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      () => {},
    )
  }, [])

  const onSubmit = (use) => {
    setLoading(true)
    if (query) {
      credentialService
        .putUpdatePassword({ ...use, token: query })
        .then(() => {
          setLoading(false)
          swal(swalMessages.RECOVER_UPDATE_SUCCESS).then(() => {
            if (!swal.getState()?.isOpen) {
              history.push('/')
            }
          })
        })
        .catch((err) => {
          console.log(err)
          setLoading(false)
          swal(swalMessages.GENERAL_ERROR)
        })
    } else if (!query) {
      credentialService
        .recoverEmail(use)
        .then(() => {
          setLoading(false)
          swal(swalMessages.RECOVER_MESSAGE).then(() => {
            if (!swal.getState()?.isOpen) {
              history.push('/')
            }
          })
          errorMsg = swalMessages.RECOVER_MESSAGE
        })
        .catch((error) => {
          setLoading(false)
          console.log(error)
        })
    }
  }

  const handlerSubmit = (event) => {
    event.preventDefault()
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action: 'submit' })
        .then((token) => {
          onSubmit({ ...user, captcha: token })
        })
    })
  }

  const onChange = (event, type) => {
    setUser({ ...user, [type]: event.target.value })
  }

  return (
    <>
        <SignIn
          onChange={onChange}
          handlerSubmit={handlerSubmit}
          user={user}
          error={errorMsg}
          disabled={false}
          show={false}
          query={query}
          title="Restablecer Contaseña"
          message={menssage}
          buttonTittle="Restablecer Contaseña"
        />
        {loading && <LinearProgress />}
    </>
  )
}

export default RecoverContainer
